import { render, staticRenderFns } from "./buttonFilesUpload.vue?vue&type=template&id=15a1d224&"
import script from "./buttonFilesUpload.vue?vue&type=script&lang=js&"
export * from "./buttonFilesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports